/** The catalog tabs' badges on the shared `ui/Badge`: always the word, the tone only repeats it. */

import { Globe, Lock } from 'lucide-react';

import { CASE_STATUSES, CASE_TYPES } from '@/api/types/cases';
import { Badge, type BadgeTone } from '@/ui/Badge';

export function AudienceBadge({ audience }: { audience: string }) {
  return <Badge variant="audience" value={audience} icon={audience === 'shareable' ? <Globe aria-hidden="true" /> : <Lock aria-hidden="true" />} />;
}

export function ProvenanceBadge({ provenance }: { provenance: string }) {
  return <Badge variant="provenance" value={provenance} />;
}

export function caseTypeLabel(type: string): string {
  return CASE_TYPES.find((t) => t.value === type)?.label ?? type;
}

export function caseStatusLabel(status: string): string {
  return CASE_STATUSES.find((s) => s.value === status)?.label ?? status;
}

const STATUS_TONE = new Map<string, BadgeTone>([
  ['live', 'success'],
  ['closed', 'success'],
  ['pilot', 'info'],
  ['pipeline', 'neutral'],
]);

export function CaseStatusBadge({ status }: { status: string }) {
  return <Badge tone={STATUS_TONE.get(status) ?? 'neutral'}>{caseStatusLabel(status)}</Badge>;
}

export function CaseTypeBadge({ type }: { type: string }) {
  return <Badge tone="neutral">{caseTypeLabel(type)}</Badge>;
}

export function ShareBadge({ shareable }: { shareable: boolean }) {
  return shareable ? (
    <Badge tone="success" icon={<Globe aria-hidden="true" />}>Shared with clients</Badge>
  ) : (
    <Badge tone="warning" icon={<Lock aria-hidden="true" />}>Internal</Badge>
  );
}
